export default __webpack_public_path__ + "static/media/voha.be14c8ec.png";